module.exports = __webpack_public_path__ + "img/Florian_Metze@2x.e06524b0.png";